import React from 'react'

import VideoPlayer from 'components/set/InteractionPlayer/VideoPlayer/VideoPlayer'
import { useStyles } from './styles'
import { Show } from 'data/Show'
import { Pass } from 'data/Pass'
import { Unpopulated } from 'data/Populated'

interface LiveVideoProps {
    show: Show
    passList: Unpopulated<Pass, 'show'>[]
    stateId: string
    muted: boolean
}

const LiveVideo: React.FC<LiveVideoProps> = ({ show, muted, stateId, passList }) => {
    const classes = useStyles()

    return (
        <div className={classes.videoWrapper} data-testid={`${stateId}_wrapper`}>
            <VideoPlayer type="live" videoTitle={show._id} show={show} muted={muted} passList={passList} />
        </div>
    )
}

export default React.memo(LiveVideo)
